






























import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppTitleBar from '@/components/AppTitleBar.vue'

import { ScrollToFetch, OrderMixin } from '@/mixins'
import { USER_POINT_HISTORY_CONNECTION } from '../gql/user'

@Component({
  components: {
    AppTitleBar
  },
  apollo: {
    user: {
      query: gql`query userAtProfilePoints($targetUserId: Int) {
        user(targetUserId: $targetUserId) {
          id
          point
          vanishPoint
        }
      }`
    },
    userPointHistoryConnection: {
      query: USER_POINT_HISTORY_CONNECTION,
      fetchPolicy: 'network-only'
    }
  }
})
export default class extends Mixins(OrderMixin, ScrollToFetch) {
  user: {
    point: number;
    vanishPoint: number;
  } = {
    point: 0,
    vanishPoint: 0
  }

  userPointHistoryConnection = { cursor: null, hasNextPage: false }

  mounted () {
    this.addScrollListener('userPointHistoryConnection', 'histories')
  }
}
